import React, { useState, useEffect } from 'react';
import './ModalConvocatoria.css';

function CloseIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path fill="currentColor" d="M12 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S2 17.53 2 12S6.47 2 12 2m3.59 5L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41z"></path>
    </svg>
  )
}

const ModalConvocatoria = ({ isOpen, onClose }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const data = [
   


    // {
    //   url: '',
    //   img: 'assets/imgs/aviso1.jpeg',
    //   img_mobile: 'assets/imgs/aviso1.jpeg'
    // },

    //     {
    //   url: 'http://declaranet.hidalgo.gob.mx:5000/',
    //   img: 'assets/imgs/declara01.jpg',
    //   img_mobile: 'assets/imgs/declara01.jpg'
    // },

    // {
    //   url: 'https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/Reel.pdf',
    //   img: 'assets/imgs/pagina web.jpg',
    //   img_mobile: 'assets/imgs/pagina web.jpg'
    // },
   

    {
      url: 'https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/TRANSP%20EN%20CORTO_CONVOCATORIA_2026.pdf',
      img: 'assets/imgs/transparencia2026.jpg',
      img_mobile: 'assets/imgs/transparencia2026.jpg',
    },
   
    // {
    //   url: 'http://declaranet.hidalgo.gob.mx:5000/',
    //   img: 'assets/imgs/declara03.jpg',
    //   img_mobile: 'assets/imgs/declara03.jpg'
    // },
   
    // {
    //   url: 'http://declaranet.hidalgo.gob.mx:5000',
    //   img: 'assets/imgs/Comunicado Normatividad.jpg',
    //   img_mobile: 'assets/imgs/Comunicado Normatividad.jpg'
    // },
   
   
   
   
   
    // {
    //   url: 'https://s-contraloria.hidalgo.gob.mx/UEEPCI',
    //   img: 'assets/imgs/UEEPCI.jpg',
    //   img_mobile: 'assets/imgs/UEEPCI.jpg'
    // },
   
    // {
    //   url: 'http://rutasdelatransformacion.hidalgo.gob.mx/',
    //   img: 'assets/imgs/trasnformacion.jpg',
    //   img_mobile: 'assets/imgs/trasnformacion.jpg'
    // },
   
    // {
    //   url: 'https://s-contraloria.hidalgo.gob.mx/interes/Convocatoria-Transparencia-en-Corto-2025.pdf',
    //   img: 'assets/imgs/premios.jpg',
    //   img_mobile: 'assets/imgs/premios.jpg'
    // },
   
    // {
    //   url: 'https://comisioncontralores.gob.mx/',
    //   img: 'assets/imgs/contralores.jpg',
    //   img_mobile: 'assets/imgs/contralores.jpg'
    // }
  ];

  useEffect(() => {
    let interval;
    if (isOpen) {
      interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => 
          prevIndex === data.length - 1 ? 0 : prevIndex + 1
        );
      }, 10000);
    }
    return () => clearInterval(interval);
  }, [isOpen, data.length]);

  if (!isOpen) {
    return null;
  }

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === data.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? data.length - 1 : prevIndex - 1
    );
  };

 
  const irConvocatoria = () => {
    const currentItem = data[currentImageIndex];
    if (currentItem && currentItem.url) {
      // Para URLs externas (http/https)
      if (currentItem.url.startsWith('http')) {
        window.open(currentItem.url, '_blank');
      } else {
        // Para archivos locales como PDFs
        window.open(currentItem.url, '_blank');
      }
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="carousel-container">
          <button className="carousel-button prev" onClick={prevImage}>&#10094;</button>
          <picture onClick={irConvocatoria}>
            <source media="(max-width: 768px)" srcSet={data[currentImageIndex].img_mobile} />
            <source media="(min-width: 769px)" srcSet={data[currentImageIndex].img} />
            <img src={data[currentImageIndex].img} alt={`Slide ${currentImageIndex + 1}`} />
          </picture>
          <button className="carousel-button next" onClick={nextImage}>&#10095;</button>
          <div className="carousel-indicators">
            {data.map((_, index) => (
              <span
                key={index}
                className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => setCurrentImageIndex(index)}
              />
            ))}
          </div>
        </div>
       
        <div
          className="button_slide slide_center"
          onClick={irConvocatoria}
        >
          IR AL ENLACE
        </div>
       

         <div className="bottomClose">
          <CloseIcon
            fontSize='30px'
            color='white'
            onClick={onClose}
          />
        </div>

        
      </div>
    </div>
  );
};

export default ModalConvocatoria;
